import { getDomainListSet, getContractHeadSet } from '@/api/contract/contract';
export default {
  namespaced: true,
  state: () => ({
    domainList: [],
    conClassifications: [],
    needRefresh: false
  }),
  mutations: {
    SET_DOMAIN(state, domainList) {
      state.domainList = domainList;
    },
    SET_CONTRACT_CLASSIFICATIONS(state, conClassifications) {
      state.conClassifications = conClassifications;
    },
    SET_NEED_REFRESH(state, needRefresh) {
      state.needRefresh = needRefresh;
    }
  },
  actions: {
    getDomainList({
      commit
    }) {
      getDomainListSet().then(res => {
        commit('SET_DOMAIN', res.d?.results || []);
        localStorage.setItem('domainList', JSON.stringify(res.d?.results || []));
      });
    },
    getConClassifications({
      commit
    }) {
      getContractHeadSet().then(res => {
        commit('SET_CONTRACT_CLASSIFICATIONS', res.d?.results || []);
        localStorage.setItem('conClassifications', JSON.stringify(res.d?.results || []));
      });
    },
    setNeedRefresh({
      commit,
      state
    }, needRefresh) {
      commit('SET_NEED_REFRESH', needRefresh);
    }
  }
};